import { AreaDefinition } from '@cibo/core'
import { AutofixButton, useGeometryEditorStateContext } from '@cibo/mapgl'
import { Alert, Stack, Typography } from '@mui/material'
import { FeatureCollection } from '@turf/turf'
import { useTranslation } from 'react-i18next'
import { BoundaryThumbnail } from '../../'

export const CreatingFieldInfo = ({
  acres,
  featureCollection,
  errorMessages,
}: {
  acres?: number
  featureCollection?: FeatureCollection
  errorMessages?: string[]
}) => {
  const { t } = useTranslation('LandManager/features/CreateLand')

  const { editorOverlaps, majorityCrops } = useGeometryEditorStateContext()

  const overlapError = !!editorOverlaps.overlaps?.length
  const noMajorityWarning = majorityCrops && majorityCrops[0] && majorityCrops[0].portion < 0.5

  const areaDef: AreaDefinition[] = []
  if (!!featureCollection) {
    featureCollection.features.forEach(feature => {
      areaDef.push({
        type: 'feature',
        // @ts-ignore does this need to be recursive?
        feature,
      })
    })
  }

  return (
    <>
      {overlapError && <AutofixButton overlaps={editorOverlaps.overlaps} />}

      <Stack direction="row" spacing={1.5} mb={2} alignItems="center">
        <BoundaryThumbnail
          boundary={{ areaDef, name: 'new field' }}
          height={36}
          width={36}
          style={{ borderRadius: 0.5 }}
        />
        <Typography variant="subtitle2">{t('acres', { count: acres })}</Typography>
      </Stack>
      {errorMessages && errorMessages.length > 0 && (
        <Alert severity={'error'}>
          <Typography>{t('acres', { count: acres })}</Typography>
          {errorMessages && errorMessages.map(message => message)}
        </Alert>
      )}
      {noMajorityWarning && (
        <Alert severity={'warning'}>
          <Typography>{t('noMajorityCrop', { year: 2022 })}</Typography>
        </Alert>
      )}
    </>
  )
}
